import { installMonkeyPatch } from '@core/patches/monkey-patch';

export function installAllPatches(): void {
    installMonkeyPatch();
}
